import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { getClassName } from '../../../utils/ui/classes';

const baseClasses = ['form-field', 'block', 'flex-none', 'w-full'];

const TextArea = forwardRef(
  ({ className, style, error, passEventOnChange, onChange, ...props }, ref) => {
    function handleChange(e) {
      if (onChange) {
        if (passEventOnChange) {
          onChange(e);
        } else {
          onChange(e.target.value);
        }
      }
    }
    return (
      /* eslint-disable jsx-a11y/no-autofocus */
      (<textarea
        ref={ref}
        className={getClassName(
          baseClasses,
          { error: error?.message },
          className,
        )}
        onChange={handleChange}
        data-testid="textArea"
        {...props}
      />)
    );
  },
);

TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  style: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string, // input autocomplete
  autoFocus: PropTypes.bool,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
};

TextArea.defaultProps = {
  rows: 3,
};

export default TextArea;
